import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from './TabPanel.js'
import EditCard from '../EditCard.js'
import ThreeGprojectPage from '../../Pages/3Gproject.js'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        minHeight: '90vh',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '200px'
    }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function ThreeGproject() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                indicatorColor="primary"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab label="Preview" {...a11yProps(0)} />
                <Tab label="Header" {...a11yProps(1)} />
                <Tab label="Carousel" {...a11yProps(2)} />
                <Tab label="Gau" {...a11yProps(3)} />
                <Tab label="Ganga" {...a11yProps(4)} />
                <Tab label="Gita" {...a11yProps(5)} />
            </Tabs>
            <TabPanel value={value} index={0} preview>
                <ThreeGprojectPage />
            </TabPanel>
            <TabPanel value={value} index={1} preview={false}>
                <EditCard title="HEADER" textKey="3g_header" imageKeys={["/images/3G/3g-bg.jpg", "/images/3G/3g-bg-mobile.jpg"]} heading subheading/>
            </TabPanel>
            <TabPanel value={value} index={2} preview={false}>
                <EditCard title="CAROUSEL 1" textKey="3g_c1_p1" imageKeys={["/images/3G/canva1.jpg"]} heading subheading titleS="Paragraph 1"/>
                <EditCard title="" textKey="3g_c1_p2" imageKeys={["/images/3G/canva2.jpg"]} subheading titleS="Paragraph 2"/>
                <EditCard title="" textKey="3g_c1_p3" imageKeys={["/images/3G/canva3.jpg"]} subheading titleS="Paragraph 3"/>
            </TabPanel>
            <TabPanel value={value} index={3} preview={false}>
                <EditCard title="GAU" textKey="3g_part1" imageKeys={["/images/3G/three-g-one.jpg", "/images/3G/three-g-one-bw.jpg"]} heading subheading/>
            </TabPanel>
            <TabPanel value={value} index={4} preview={false}>
                <EditCard title="GANGA" textKey="3g_part2" imageKeys={["/images/3G/three-g-two.jpg", "/images/3G/three-g-two-bw.jpg", "/images/3G/three-g-ganga-mobile.jpg"]} heading subheading/>
            </TabPanel>
            <TabPanel value={value} index={5} preview={false}>
                <EditCard title="GITA" textKey="3g_part3" imageKeys={["/images/3G/three-g-three.jpg", "/images/3G/three-g-three-bw.jpg"]} heading subheading/>
            </TabPanel>
        </div>
    );
}
